<template>
    <b-modal id="imc_main_modal" v-bind:no-close-on-backdrop=true v-model="show"  modalClass="modal-alert" bodyClass="p-0">
        <template v-slot:modal-header="{ close }">
            <h5 class="modal-title">
                {{title}}
            </h5>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close('no')">
                <span aria-hidden="true"><i class="fal fa-times"></i></span>
            </button>

        </template>

        <div class="description">
            {{html}}
        </div>

        <template  slot="modal-footer" slot-scope="{ ok, cancel }">
            <div class="main_burttons" v-if="show_buttons">
                <b-button  size="lg" class="shadow-0 mr-2" variant="primary" @click.prevent="close('ok')">
                    Гаразд
                </b-button>

                <b-button size="lg" class="shadow-0 mr-2" variant="danger" @click="close('no')">
                    Скасувати
                </b-button>
            </div>
            <div class="disable_button" v-else>

            </div>

        </template>
    </b-modal>
</template>

<script>
    export default {
        name: "confirm",

        data() {
            return {
                show: false,
                worker : null,

                show_buttons: true,
                can_close: true,
                title: 'IMC TITLE',
                html: ''
            }
        },

        created() {
            EventBus.$on('show_imc_confirm', e => {
                this.title = e.title;
                this.html = e.html;

                if(e.worker != undefined) {
                    this.worker = e.worker;
                }

                if (e.center !== undefined) {
                    this.centerd = e.center;
                }

                if (e.params !== undefined) {

                    if (e.params.show_buttons !== undefined) {
                        this.show_buttons = e.params.show_buttons;
                    }
                }

                this.show = true;
            });


            EventBus.$on('close_imc_confirm', e => {
                let delay = e.delay;
                setTimeout(() => this.show = false, delay);

            });
        },

        methods: {

            kill () {
                this.show = false;
            },

            close(type) {
                if(this.worker !== undefined) {

                    if(type === "ok") {
                        this.worker.resolve("OK");
                    }
                    else {
                        this.worker.reject(type);
                    }
                }

                if(this.can_close) {
                    this.show = false;
                }
            }
        },

    }
</script>

<style scoped>

</style>
